



import { Component, Vue } from 'vue-property-decorator'

@Component
export default class ProlongationCourse extends Vue {
  private get courseID() {
    return +this.$route.params.courseID
  }

  private mounted() {
    const courseID = this.courseID
    this.$router.replace({
      name: 'master',
    })
      .then(() => {
        this.$bus.$emit('openNotPaid', courseID)
      })
  }
}
